import React from "react";
import { Formik } from "formik";
import { Grid } from "@material-ui/core";

import ModalDomain from "./domain";
import AppModal from "../app-modal";
import ValidationSchema from "./validation-schema";
import PasswordInputField from "../../../common/password-input-field";
import PasswordRequirementValidator from "../../../common/password-requirement-validator";

import "./style.css";

const UserPasswordUpdateModal = ({ adDetails, showModal, closeModal }) => {
  const onSubmit = ({ values, setSubmitting, resetForm }) => {
    ModalDomain.updateUserPassword({
      values,
      setSubmitting,
      closeModal,
      resetForm,
    });
  };

  return (
    <Grid container className="password-update-modal">
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
          memberId: adDetails.ad.memberId,
        }}
        validationSchema={ValidationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) =>
          onSubmit({ values, setSubmitting, resetForm })
        }
        validateOnMount={false}
      >
        {({
          values,
          errors,
          submitCount,
          isSubmitting,
          handleChange,
          handleSubmit,
          isValid,
        }) => {
          return (
            <AppModal
              visibility={showModal}
              handleClose={closeModal}
              title="Update Password"
              primaryLabel="Update"
              onPrimaryAction={handleSubmit}
              onSecondaryAction={closeModal}
              disablePrimaryAction={
                isSubmitting || (!isValid && submitCount > 0)
              }
              loading={isSubmitting}
            >
              <form onSubmit={handleSubmit} className="password-update-form">
                <Grid container direction="column">
                  <PasswordInputField
                    label="New Password"
                    fieldName="password"
                    placeholder="Enter password"
                    handleChange={handleChange}
                    values={values.password}
                    autoFocus={true}
                    error={submitCount > 0 && errors.password}
                  />
                  <PasswordRequirementValidator password={values.password} />
                </Grid>
                <PasswordInputField
                  label="Confirm Password"
                  fieldName="confirmPassword"
                  placeholder="Confirm password"
                  handleChange={handleChange}
                  values={values.confirmPassword}
                  error={submitCount > 0 && errors.confirmPassword}
                />
              </form>
            </AppModal>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default UserPasswordUpdateModal;
